import React, { useState } from "react";
import { Button, Checkbox, FormControlLabel, FormGroup, Typography } from "@mui/material";
import { PaletaColor } from "../styles/StylesConstantes";
import { CssTextField } from "../styles/styles";
import { AddAPhoto, Delete } from "@mui/icons-material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from "@mui/x-date-pickers";
import "dayjs/locale/es";


function AddSorteoComponents({
    id, titulo, setTitulo, linkUrl, setLinkUrl, imagen, handleRemoverImagen, activoStatus, setActivoStatus, sorteoEspecial,
    setSorteoEspecial, fechaInicioVigenciaFacturas, handleFechaInicioVigenciaFacturas, fechaHastaVigenciaFacturas,
    handleFechaHastaVigenciaFacturas,
    handleCancelar, handleGuardar, handleUpdateSorteo, handleAgregarImagen, descripcion, setDescripcion, ratioGuaranies,
    setRatioGuaranies,
    ratioDolares, setRatioDolares, ratioGuaraniesCheck, setRatioGuaraniesCheck, ratioDolaresCheck, setRatioDolaresCheck,
    fechaInicio, handleFechaInicio, fechaHasta, handleFechaHasta, fechaInicioPublicacion, handleFechaInicioPublicacion,
    fechaHastaPublicacion, handleFechaHastaPublicacion, imagenDetalle, handleRemoverImagenDetalle, handleAgregarImagenDetalle,
    loadingGuardar
}) {

    const [errorImagen, setErrorImagen] = useState('');
    const [errorImagenDetalle, setErrorImagenDetalle] = useState('');

    const handleValidarImagen = (e, callback, setError) => {
        const file = e.target.files[0];
        if (!file) return;
        const img = new Image();
        img.onload = () => {
            if (img.width !== 720 || img.height !== 400) {
                setError(`La imagen debe ser exactamente 720x400 px. La imagen seleccionada es ${img.width}x${img.height} px.`);
                e.target.value = '';
            } else {
                setError('');
                callback(e);
            }
            URL.revokeObjectURL(img.src);
        };
        img.src = URL.createObjectURL(file);
    };

    return (
        <div className="grid grid-cols-1 xl:grid-cols-[minmax(320px,720px)_minmax(0,1fr)] gap-6 xl:gap-8">
            <div className="w-full max-w-[720px]">
                <div className="bg-white rounded-xl border border-gray-200 p-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Imagen del inicio (720x400)</label>
                    <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 hover:border-gray-400 transition-colors bg-gray-50/40">
                        <input
                            type="file"
                            accept="image/*"
                            style={{ display: 'none' }}
                            id="file-input"
                            onChange={(e) => handleValidarImagen(e, handleAgregarImagen, setErrorImagen)}
                        />

                        {errorImagen && (
                            <p className="text-xs text-red-500 mb-2">{errorImagen}</p>
                        )}
                        {imagen === '' ? (
                            <label htmlFor="file-input" className="cursor-pointer flex flex-col items-center text-center py-6">
                                <AddAPhoto className="text-gray-400 mb-2" style={{ fontSize: 34 }} />
                                <p className="text-sm text-gray-700">Seleccionar imagen</p>
                                <p className="text-xs text-gray-500 mt-1">PNG o JPG con tamaño 720x400</p>
                            </label>
                        ) : (
                            <div className="flex flex-col items-center justify-center gap-3">
                                <img
                                    src={imagen}
                                    alt={'imagen inicio'}
                                    className="w-full max-w-[520px] rounded-md object-cover border border-gray-200"
                                    style={{ aspectRatio: '720 / 400' }}
                                />
                                <Button
                                    type="button"
                                    onClick={handleRemoverImagen}
                                    variant="text"
                                    color="error"
                                    startIcon={<Delete fontSize="small" />}
                                    sx={{ textTransform: 'none', fontWeight: 600 }}
                                >
                                    Quitar imagen
                                </Button>
                            </div>
                        )}
                    </div>
                </div>

                <div className="bg-white rounded-xl border border-gray-200 p-4 mt-6">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Imagen del detalle (720x400)</label>
                    <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 hover:border-gray-400 transition-colors bg-gray-50/40">
                        <input
                            type="file"
                            accept="image/*"
                            style={{ display: 'none' }}
                            id="file-input-detalle"
                            onChange={(e) => handleValidarImagen(e, handleAgregarImagenDetalle, setErrorImagenDetalle)}
                        />

                        {errorImagenDetalle && (
                            <p className="text-xs text-red-500 mb-2">{errorImagenDetalle}</p>
                        )}
                        {imagenDetalle === '' ? (
                            <label htmlFor="file-input-detalle" className="cursor-pointer flex flex-col items-center text-center py-8">
                                <AddAPhoto className="text-gray-400 mb-2" style={{ fontSize: 34 }} />
                                <p className="text-sm text-gray-700">Seleccionar imagen</p>
                                <p className="text-xs text-gray-500 mt-1">PNG o JPG con tamaño 720x400</p>
                            </label>
                        ) : (
                            <div className="flex flex-col items-center justify-center gap-3">
                                <img
                                    src={imagenDetalle}
                                    alt={'imagen detalle'}
                                    className="w-full max-w-[520px] rounded-md object-cover border border-gray-200"
                                    style={{ aspectRatio: '720 / 400' }}
                                />
                                <Button
                                    type="button"
                                    onClick={handleRemoverImagenDetalle}
                                    variant="text"
                                    color="error"
                                    startIcon={<Delete fontSize="small" />}
                                    sx={{ textTransform: 'none', fontWeight: 600 }}
                                >
                                    Quitar imagen
                                </Button>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="w-full min-w-0">

                <CssTextField
                    value={titulo}
                    onChange={(e) => setTitulo(e.target.value)}
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    label="Titulo"
                    autoCapitalize='none'
                    autoCorrect={"false"}
                    style={{ marginTop: 8 }}
                />

                <CssTextField
                    value={descripcion}
                    onChange={(e) => setDescripcion(e.target.value)}
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    label="Descripción"
                    autoCapitalize='none'
                    autoCorrect={"false"}
                    style={{ marginTop: 8 }}
                    //permite multilinea en el input de texto al presionar enter
                    multiline
                    minRows={4}
                />

                <CssTextField
                    value={linkUrl}
                    onChange={(e) => setLinkUrl(e.target.value)}
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    label="Link"
                    autoCapitalize='none'
                    autoCorrect={"false"}
                    style={{ marginTop: 8 }}
                />

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
                    <div>
                        <Typography variant={'subtitle1'} style={{ color: PaletaColor.NEGRO, marginTop: 8 }}>
                            Ratio Guaranies
                        </Typography>

                        <CssTextField
                            value={ratioGuaranies}
                            onChange={(e) => setRatioGuaranies(e.target.value)}
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            label="Ratio Guaranies"
                            autoCapitalize='none'
                            autoCorrect={"false"}
                            style={{ marginTop: 8 }}
                        />
                    </div>

                    <div>
                        <Typography variant={'subtitle1'} style={{ color: PaletaColor.NEGRO, marginTop: 8 }}>
                            Ratio Dolares
                        </Typography>

                        <CssTextField
                            value={ratioDolares}
                            onChange={(e) => setRatioDolares(e.target.value)}
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            label="Ratio Dolares"
                            autoCapitalize='none'
                            autoCorrect={"false"}
                            style={{ marginTop: 8 }}
                        />
                    </div>

                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
                    <div>
                        <Typography variant={'subtitle1'} style={{ color: PaletaColor.NEGRO, marginTop: 8 }}>
                            Ratio Guaranies Check
                        </Typography>

                        <CssTextField
                            value={ratioGuaraniesCheck}
                            onChange={(e) => setRatioGuaraniesCheck(e.target.value)}
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            label="Ratio Guaranies Check"
                            autoCapitalize='none'
                            autoCorrect={"false"}
                            style={{ marginTop: 8 }}
                        />
                    </div>

                    <div>
                        <Typography variant={'subtitle1'} style={{ color: PaletaColor.NEGRO, marginTop: 8 }}>
                            Ratio Dolares Check
                        </Typography>

                        <CssTextField
                            value={ratioDolaresCheck}
                            onChange={(e) => setRatioDolaresCheck(e.target.value)}
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            label="Ratio Dolares Check"
                            autoCapitalize='none'
                            autoCorrect={"false"}
                            style={{ marginTop: 8 }}
                        />
                    </div>

                </div>


                <Typography variant={'subtitle1'} style={{ color: PaletaColor.NEGRO, marginTop: 8 }}>
                    Vigencia del Sorteo
                </Typography>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-3">
                    <div>
                        <LocalizationProvider adapterLocale="es" dateAdapter={AdapterDayjs}>
                            <DateTimePicker
                                label="Desde"
                                value={fechaInicio}
                                //agregar el formato de 24 horas y la fecha en formato DD/MM/YYYY
                                format="DD/MM/YYYY HH:mm:ss"
                                //formato de 24 horas
                                ampm={false}
                                onChange={(newValue) => {
                                    handleFechaInicio(newValue);
                                }}
                                sx={{ width: '100%' }}

                            />
                        </LocalizationProvider>
                    </div>

                    <div>
                        <LocalizationProvider adapterLocale="es" dateAdapter={AdapterDayjs}>
                            <DateTimePicker
                                label="Hasta"
                                value={fechaHasta}
                                //agregar el formato de 24 horas y la fecha en formato DD/MM/YYYY
                                format="DD/MM/YYYY HH:mm:ss"
                                //formato de 24 horas
                                ampm={false}
                                onChange={(newValue) => {
                                    handleFechaHasta(newValue);
                                }}
                                sx={{ width: '100%' }}
                            />
                        </LocalizationProvider>
                    </div>
                </div>


                <div style={{ marginTop: 16 }}>
                    <Typography variant={'subtitle1'} style={{ color: PaletaColor.NEGRO, marginTop: 8 }}>
                        Vigencia de la Publicación
                    </Typography>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-3">
                    <div>
                        <LocalizationProvider adapterLocale="es" dateAdapter={AdapterDayjs}>
                            <DateTimePicker
                                label="Desde"
                                value={fechaInicioPublicacion}
                                //agregar el formato de 24 horas y la fecha en formato DD/MM/YYYY
                                format="DD/MM/YYYY HH:mm:ss"
                                //formato de 24 horas
                                ampm={false}
                                onChange={(newValue) => {
                                    handleFechaInicioPublicacion(newValue);
                                }}
                                sx={{ width: '100%' }}

                            />
                        </LocalizationProvider>
                    </div>

                    <div>
                        <LocalizationProvider adapterLocale="es" dateAdapter={AdapterDayjs}>
                            <DateTimePicker
                                label="Hasta"
                                value={fechaHastaPublicacion}
                                //agregar el formato de 24 horas y la fecha en formato DD/MM/YYYY
                                format="DD/MM/YYYY HH:mm:ss"
                                //formato de 24 horas
                                ampm={false}
                                onChange={(newValue) => {
                                    handleFechaHastaPublicacion(newValue);
                                }}
                                sx={{ width: '100%' }}
                            />
                        </LocalizationProvider>
                    </div>
                </div>

                <FormGroup style={{ marginTop: 16 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={activoStatus} // Componente controlado
                                onChange={(e) => setActivoStatus(e.target.checked)}
                            />
                        }
                        label="Es Prueba?"
                    />
                </FormGroup>

                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={sorteoEspecial} // Componente controlado
                                onChange={(e) => setSorteoEspecial(e.target.checked)}
                            />
                        }
                        label="Sorteo Especial?"
                    />
                </FormGroup>

                {sorteoEspecial && (
                    <div style={{ marginTop: 16 }}>
                        <Typography variant={'subtitle1'} style={{ color: PaletaColor.NEGRO, marginTop: 8 }}>
                            Vigencia de Facturas
                        </Typography>
                    </div>
                )}

                {sorteoEspecial && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-3">
                        <div>
                            <LocalizationProvider adapterLocale="es" dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                    label="Desde"
                                    value={fechaInicioVigenciaFacturas}
                                    //agregar el formato de 24 horas y la fecha en formato DD/MM/YYYY
                                    format="DD/MM/YYYY HH:mm:ss"
                                    //formato de 24 horas
                                    ampm={false}
                                    onChange={(newValue) => {
                                        handleFechaInicioVigenciaFacturas(newValue);
                                    }}
                                    sx={{ width: '100%' }}

                                />
                            </LocalizationProvider>
                        </div>

                        <div>
                            <LocalizationProvider adapterLocale="es" dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                    label="Hasta"
                                    value={fechaHastaVigenciaFacturas}
                                    //agregar el formato de 24 horas y la fecha en formato DD/MM/YYYY
                                    format="DD/MM/YYYY HH:mm:ss"
                                    //formato de 24 horas
                                    ampm={false}
                                    onChange={(newValue) => {
                                        handleFechaHastaVigenciaFacturas(newValue);
                                    }}
                                    sx={{ width: '100%' }}
                                />
                            </LocalizationProvider>
                        </div>
                    </div>
                )}

               

            </div>

            <div className="xl:col-start-1 xl:col-end-2 flex justify-start gap-3 p-2">
                <button
                    type="submit"
                    disabled={loadingGuardar}
                    onClick={id ? handleUpdateSorteo : handleGuardar}
                    className="px-6 py-2 bg-[#104063] hover:bg-[#0d3553] disabled:opacity-70 text-white rounded-lg font-medium transition-colors"
                >
                    {loadingGuardar ? "Guardando..." : id ? "Guardar Cambios" : "Guardar"}
                </button>

                <button
                    type="button"
                    onClick={handleCancelar}
                    className="px-6 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors"
                >
                    Cancelar
                </button>

            </div>
        </div>
    )
}

export default AddSorteoComponents;